<template>
<div v-bind:class="{'ui loading form': (loaded==1)}">
  <form class="ui form segment">
    <app-header v-if="showMenu" ></app-header>
    <div class="ui block header">
      
      <div class="four fields">
        <div class="field">
            <label>Document Name</label>
              <label >{{ this.document_name }} </label>
          </div>
          <div class="field">
            <label>Type</label>
              <label >{{ this.document_type }}</label>
          </div>
          <div class="field">
            <label>PO Date</label>
            <label >{{ this.date_received }}</label>
          </div>
          <div class="field">
            <label>Transaction ID</label>
              <label >{{ this.transaction_id }}</label>
          </div>
      </div>
    </div>
   

<div class="ui attached segment">
  <div class="four fields">
   <div class="field">
      <label>Community</label>
      <select class="ui dropdown" v-model="communitySelected" style="width:450px" @change="communityChangedValue(communitySelected)">
       <option v-for="community in communities" v-bind:value="community.community_id" v-bind:key="community.community_id" >
        {{ community.community_name }}
       </option>
      </select>
      
    </div>
     <div class="field">
       <br />
       <div class="ui primary submit button"  @click="autoFill()">Auto Fill</div>
      </div> 
  
  </div>
 
  <div class="four fields">
   <div class="field" >
      <label>Vendor</label>
      <select class="ui dropdown" v-model="vendorSelected" @change="vendorChangedValue(vendorSelected)">
       <option value="-1">--Select--</option>
       <option v-for="vendor in vendorDetails" v-bind:value="vendor.vendor_id" v-bind:key="vendor.vendor_id">
        {{ vendor.vendor_name }}
       </option>
      </select>
    </div>
    <div class="field">
      <label>Buyer</label>
    <select class="ui dropdown" v-model="buyerSelected" @change="buyerChangedValue(buyerSelected)">
      <option value="-1">--Select--</option>
       <option v-for="buyer in buyerDetails" v-bind:value="buyer.buyer_id" v-bind:key="buyer.buyer_id">
        {{ buyer.buyer_name }}
       </option>
      </select>
    </div>
    <div class="field">
      <label>Ship Location</label>
      <select class="ui dropdown" v-model="shipSelected" @change="shipChangedValue(shipSelected)">
         <option value="-1">--Select--</option>
        <option v-for="shipLocation in shipDetails" v-bind:value="shipLocation.location_id" v-bind:key="shipLocation.location_id">
        {{ shipLocation.location_name }}
       </option>
      </select>
    </div>
    <div class="field">
      <label>Currency</label>
      <select class="ui dropdown" name="currency" v-model="currencySelected" @change="currencyChangedValue(currencySelected)">
       <option v-for="currency in currencies" v-bind:value="currency.currency_type_id" v-bind:key="currency.currency_type_id" >
            {{ currency.currency_type_code }}
        </option>
      </select>
    </div>
  </div>
  <div class="four fields">
    <div class="field">
      <label>Vendor Code</label>
      <input placeholder="Vendor Code" name="_vendorcode" type="text"  ref="ipVendorCode"  v-model= "this.seller_code">
    </div>
   <div class="field">
      <label>Buyer Code</label>
      <input placeholder="Buyer Code" name="buyercode" type="text"  ref="ipBuyeCode"   v-model= "this.buyerCode">
    </div>
    <div class="field">
      <label>Ship Code</label>
      <input placeholder="Ship Code" name="shipcode" type="text" ref="ipShipCode"   v-model= "this.shipCode">
    </div>
     <div class="field">
      <label>Route</label>
      <select class="ui dropdown"  name="route"  v-model="routeSelected" @change="routeChangedValue(currencySelected)"> 
       <option v-for="route in routes" v-bind:value="route.routing_id" v-bind:key="route.routing_id" >
            {{ route.description }}
        </option>
      </select>
    </div>
  </div>
  <br />
  <div class="four fields">
    <div class="field">
      <label>Vendor Details</label>
      <textarea disabled name="vendordetails" id="vendordetails"  rows="6" style="width:365px" v-model = "vendorAddress"></textarea>
    </div>
   <div class="field">
      <label>Buyer Details</label>
      <textarea disabled name="buyerdetails" id="buyerdetails"  rows="6" style="width:365px" v-model = "buyerAddress"></textarea>
    </div>
   <div class="field">
      <label>Ship To Location Details</label>
      <textarea disabled name="shipdetails" id="shipdetails" cols="20" rows="6" style="width:365px" v-model = "shipAddress"></textarea>
    </div>
  </div>
 <!-- <div class="ui primary submit button" >Save Changes</div> -->
  <div class="ui primary submit button"  @click="updateCorssRef()">Update Cross Ref & Route</div>
  <div class="ui button"  @click="closeWindow()">Close Current Window</div>
  <div class="ui error message"></div>
  
  
 <div class="ui modal">
  <i class="close icon"></i>
  <div class="header">
    Do you want to continue?
  </div>
  
  <div class="actions">
    <div class="ui black deny button">
      Nope
    </div>
    <div class="ui positive right labeled icon button">
     Yes
      <i class="checkmark icon"></i>
    </div>
  </div>
</div>
 </div> 






  <div class="four fields">
    <div class="field">
       <br />
     Vendor 
     <br />
    <textarea v-show="xmlVisible" v-model="vendorData"  id="billTo" rows="5"></textarea>
   </div>
    <div class="field">
       <br />
     Buyer 
     <br />
    <textarea v-show="xmlVisible" v-model="buyerData"  id="billTo" rows="5"></textarea>
   </div>
   <div class="field">
      <br />
    Location
     <br />
    <textarea v-show="xmlVisible" v-model="locationData"  id="shipTo" rows="5"></textarea>
   </div>
    <div class="field">
     <br />
         <i id="xmlDataIcon"  v-bind:class="{'angle double up icon': isUp, 'angle double down icon': isDown }" @click="showHideXmlData()" ></i>
      Raw XML Transaction 
    <textarea v-show="xmlVisible" v-model="rawXMLTransactionData"  id="xmlData" rows="50"></textarea>
   </div>
  </div>
   </form>
  </div>
 
</template>

<script>
import axios from "axios";
import Header from '@/components/Header.vue';
import Vue from 'vue'

export default {
  components: {
    appHeader: Header
  },
  data () {
    return {
      loaded : "1",
      showMenu :false,
      communities : [],
      headerData : [],
      vendorCode : "",
      communitySelected :"",
      communityId : "",
      documentId: "",
      vendorDetails:[],
      vendorSelected :"",
      buyerDetails:[],
      buyerSelected :"",
      shipDetails:[],
      shipSelected :"",
      vendorAddressDetails:[],
      vendorAddress : "",
      buyerAddress : "",
      shipAddress : "",
      resultData :[],
      tokenExpired : 0,
      xmlVisible : true,
      isUp : false,
      isDown :true,
      rawXMLTransactionData : "",
      routes :[],
      routeSelected : "",
      currencies : [],
      currencySelected : "",
      document_name : "" ,
      document_type : "" ,
      date_received : "" ,
      transaction_id : "" ,
      seller_code : "" ,
      buyerCode : "" ,
      shipCode : "" ,
      vendor_code : "",
      buyer_code : "" ,
      ship_code : "" ,
      vendor_id : "",
      buyer_id : "",
      ship_id : "",
      currency_id : "",
      currency_code : "",
      document_id : "",
      community_id : "",
      routing_id : "",
      input: {
        refreshtoken : ""
      }   ,
      diffMins : 0,
      refreshToken_Event_Fired : 0 ,
      buyerData : "",
      vendorData : "",
      locationData : "",
      vendor_id_selected :"",
      buyer_id_selected :"",
      ship_id_selected :"",
      currency_id_selected :"",
      defaultCommunity : 0,
      doc_type_id:""
   }
 },
 methods: {
    bindCommunity(){
        if(localStorage.getItem('id_token')){
         axios({ method: "GET", "url": Vue.prototype.$hostname +  "lookup/community", 
               "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.communities = result.data;
                    this.communitySelected =  CryptoJS.AES.decrypt( this.$route.query.comId, 'corcentric').toString(CryptoJS.enc.Latin1);
                     this.shipSelected = "-1";
                   }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
        } 
    },
    bindHeaderData(){
         if(localStorage.getItem('id_token')){
         this.loaded = 1;
         axios({ method: "GET", "url": Vue.prototype.$hostname + "documents/" + this.communityId + "/null/-1/null/null/N" + "?doc_id=" +this.documentId, 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.headerData = result.data;
                    this.vendorCode = this.headerData[0].vendorCode;
                    this.document_name = this.headerData[0].document_name;
                    this.document_type = this.headerData[0].document_type;
                    this.date_received = this.headerData[0].date_received;
                    this.transaction_id = this.headerData[0].transaction_id;
                    this.seller_code = this.headerData[0].seller_code;
                    this.buyerCode = this.headerData[0].buyer_code;
                    this.shipCode = this.headerData[0].ship_code;
                    this.doc_type_id =  this.headerData[0].doc_type_id;
               }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
        }       
    },
     bindRawXMLTransaction(community,created){

     
      if(localStorage.getItem('id_token')){
         this.loaded = 1;
         axios({ method: "GET", "url": Vue.prototype.$hostname + "documentxmltrxn/" + community + "/" + this.documentId + "/" + this.defaultCommunity ,
       
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {

                        //this.buyerData = "";
                        if(created == 1){
                        this.rawXMLTransactionData =  this.formatXml(result.data.xml_data);
                        
                        this.buyerData = this.formatAddress(result.data.buyer_data) ;  
                        this.vendorData = this.formatAddress(result.data.vendor_data) ; 
                        this.locationData = this.formatAddress(result.data.location_data) ; 
                        this.currency_id_selected = result.data.error_category_code /* currency id */
                        }

                        console.log('Vendor ID :' + result.data.vendor_id);
                        console.log('Buyer ID :' + result.data.buyer_id);
                        console.log('Ship ID :' + result.data.ship_id);
                        this.vendor_id_selected = result.data.vendor_id;
                        this.buyer_id_selected = result.data.buyer_id;
                        this.ship_id_selected = result.data.ship_id;
                        
                        

                  }, 
                error => {
                    console.error(error);
                     this.sessionExpired(error.response.status);
                });
        }       
    },
    formatAddress(address){
         var data = "";
         if ( address != null && address != ""){
      var array = address.split(',');
    
      
      array.forEach(function (item, index) {
      if (item){
      if ( data != null && data != ""){
      if(item != "-"){
      data =  data +  "\n" + item ;
      }}else{
      data = item ;
      }}
      });
         }
      return data;
    },
    formatXml(xml) {

    const PADDING = ' '.repeat(2); // set desired indent size here
    const reg = /(>)(<)(\/*)/g;
    let pad = 0;

    xml = xml.replace(reg, '$1\r\n$2$3');

    return xml.split('\r\n').map((node, index) => {
        let indent = 0;
        if (node.match(/.+<\/\w[^>]*>$/)) {
            indent = 0;
        } else if (node.match(/^<\/\w/) && pad > 0) {
            pad -= 1;
        } else if (node.match(/^<\w[^>]*[^\/]>.*$/)) {
            indent = 1;
        } else {
            indent = 0;
        }

        pad += indent;

        return PADDING.repeat(pad - indent) + node;
    }).join('\r\n');
},
    bindVendorDetails(communitySelected){
      this.loaded = 1;
         axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/vendor/" + communitySelected, 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                  result => {
                  localStorage.removeItem('vendorSelected');
                 this.vendorDetails = result.data;
                
                if(this.vendorDetails.length){
                  this.vendorSelected = "-1"; /* this.vendorDetails[0].vendor_id; */
                  localStorage.removeItem('vendorSelected');
                    localStorage.setItem('vendorSelected',this.vendorSelected) ; 
                  /*
                  this.resultData = this.vendorDetails.filter(x=> x.vendor_code === this.vendorCode);
                  this.vendorSelected = this.resultData[0].vendor_id; */
                  /*this.vendorDetails[0].vendor_id;*/
                  /*localStorage.setItem('vendorSelected',this.vendorSelected) ;*/
                    
                }
                else{
                    this.vendorSelected = "-1";
                    localStorage.removeItem('vendorSelected');
                    localStorage.setItem('vendorSelected',this.vendorSelected) ;
                }
            
                
                  this.bindVendorAddress(communitySelected);
                }, 
                error => {
                    console.error(error);
                     this.sessionExpired(error.response.status);
                });
    },
     bindBuyerDetails(communitySelected){
         axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/buyer/" + communitySelected, 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.buyerDetails = result.data;
                    this.buyerSelected = "-1"
                     /*
                     if(this.buyer_id_selected != null && this.buyer_id_selected != ""){
                    this.buyerSelected =  this.buyer_id_selected;
                    this.bindLocationDetails(this.buyerSelected);
                    
                     }
                    else{
                      this.buyerSelected = "-1"; 
                    }*/
                   
                    this.loaded = 2;
                   //this.bindBuyerAddress();
                  }, 
                error => {
                    console.error(error);
                     this.sessionExpired(error.response.status);
                });
    },
    bindLocationDetails(buyerSelected){
        this.loaded = 1; 
         axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/shiptolocation/" + this.communitySelected +"/" + buyerSelected, 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.shipDetails = result.data;

                    /*
                     if(this.ship_id_selected != null && this.ship_id_selected != "")
                    this.shipSelected =  this.ship_id_selected
                    else{
                      this.shipSelected = "-1"; 
                    }
                    this.shipAddress = "";
                    this.bindshipAddress();
                    
                    */

                    
                   this.loaded = 2; 
                  }, 
                error => {
                    console.error(error);
                     this.sessionExpired(error.response.status);
                });
               /*  this.loaded = 2; */
                //this.shipSelected = "-1";
    },
    autoFill(){
       if(this.vendor_id_selected != null && this.vendor_id_selected != ""){
          this.vendorSelected =  this.vendor_id_selected;
           localStorage.removeItem('vendorSelected');
           localStorage.setItem('vendorSelected',this.vendor_id_selected) ;
           this.bindVendorAddress(this.communitySelected);
        }
        if(this.buyer_id_selected != null && this.buyer_id_selected != ""){
          this.buyerSelected =  this.buyer_id_selected;
          this.bindLocationDetails(this.buyerSelected);
           this.bindBuyerAddress();
        }
         if(this.ship_id_selected != null && this.ship_id_selected != ""){
          this.shipSelected =  this.ship_id_selected;
        
           this.bindshipAddress();
        }
         if(this.currency_id_selected != null && this.currency_id_selected != ""){
          this.currencySelected =  this.currency_id_selected;

        }
    },
    bindVendorAddress(communitySelected){
         this.loaded = 1;
             
         if(localStorage.getItem('vendorSelected') != null && localStorage.getItem('vendorSelected') !== "undefined" && localStorage.getItem('vendorSelected') != "-1" ){
           
         axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/vendorinfo/" + this.communitySelected + "/" + localStorage.getItem('vendorSelected') , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                 
                    result => {
                        this.vendorAddress =  result.data.name + "\n" +  result.data.address1 + "\n" +
                        result.data.address2 + "\n" +  result.data.city + "\n" +
                        result.data.state + "-" + result.data.postal_code  + "\n" + 
                        result.data.country_code 
                      this.loaded = 2;   
                  }, 
                error => {
                    console.error(error);
                     this.sessionExpired(error.response.status);
                });
         }
         else{
            this.vendorAddress = "";
             this.loaded = 2;
         }
        
    },
    bindBuyerAddress(){
     
         /* this.loaded = 1; */
         if(localStorage.getItem('vendorSelected') && this.buyerSelected != -1){
         axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/buyerinfo/" + this.communitySelected + "/" + this.buyerSelected , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                 
                    result => {
                        this.buyerAddress =  result.data.name + "\n" +  result.data.address1 + "\n" +
                        result.data.address2 + "\n" +  result.data.city + "\n" +
                        result.data.state + "-" + result.data.postal_code  + "\n" + 
                        result.data.country_code  
                        /* this.loaded = 2;  */ 
                  }, 
                error => {
                    console.error(error);
                     this.sessionExpired(error.response.status);
                });
         }
         else{
            this.buyerAddress = "";
             /* this.loaded = 2;  */ 
         }
         
    },
    bindshipAddress(){
        //alert(this.shipSelected)
         this.loaded = 1;
         if(this.shipSelected != -1){
           axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/shiptoinfo/" + this.communitySelected + "/" + this.shipSelected , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                 
                    result => {
                        this.shipAddress =  result.data.name + "\n" +  result.data.address1 + "\n" +
                        result.data.address2 + "\n" +  result.data.city + "\n" +
                        result.data.state + "-" + result.data.postal_code  + "\n" + 
                        result.data.country_code 
                        this.loaded = 2;    
                  }, 
                error => {
                    console.error(error);
                     this.sessionExpired(error.response.status);
                });
         }
         else{
             this.shipAddress = "";
             this.loaded = 2;
         }
        
    },
    communityChangedValue(communitySelected) {
      
      
      this.checkTokenExpired();
      this.bindRawXMLTransaction(this.communitySelected,0);  
      this.bindVendorDetails(this.communitySelected);
         
       
       this.bindBuyerDetails(this.communitySelected);
       


       this.getRoutingIdByCommunity(this.communitySelected); 
        
  
    
       this.buyerAddress = "";
       this.shipAddress = "";
       this.shipDetails= []

    },
    vendorChangedValue(vendorSelected){
      this.checkTokenExpired();
      localStorage.removeItem('vendorSelected');
      localStorage.setItem('vendorSelected',this.vendorSelected) ;
      this.bindVendorAddress(this.communitySelected);
    },
    buyerChangedValue(buyerSelected){
      this.checkTokenExpired();
      this.bindBuyerAddress();
      this.bindLocationDetails(this.buyerSelected);
     
      },
    shipChangedValue(shipSelected){
       this.checkTokenExpired();
      this.bindshipAddress();
    },
    currencyChangedValue(shipSelected){
       this.checkTokenExpired();
    },
    routeChangedValue(shipSelected){
       this.checkTokenExpired();
    },
    sessionExpired(errorStatus){
      if (errorStatus === 403 && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Sesssion expired.Please login again!!');
        this.$router.push({name: 'Login'});
    }
   },
   showHideXmlData(){
    this.checkTokenExpired();
     if(document.getElementById('xmlDataIcon').getAttribute('class')==="angle double up icon"){
       this.isDown = true;
       this.isUp = false;
     }
     else if(document.getElementById('xmlDataIcon').getAttribute('class')==="angle double down icon"){
        this.isDown = false;
       this.isUp = true;
     }
     if(this.xmlVisible)this.xmlVisible = false ;
     else this.xmlVisible = true;
    },
   bindRoutes(){
      axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/routing/" , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                  result => {
                     this.routes = result.data;
                      this.routeSelected = "0";
                    
                 }, 
                error => {
                    console.error(error);
                     this.sessionExpired(error.response.status);
                });
   },

   closeWindow(){
    window.close();
  },

  bindCurrency(){
     axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/currency/" , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                  result => {
                     this.currencies = result.data;
                      if(this.currency_id_selected != null && this.currency_id_selected != ""){
                        this.currencySelected =  this.currency_id_selected;

                      }
                     //this.currencySelected = "2";
                    
                 }, 
                error => {
                    console.error(error);
                     this.sessionExpired(error.response.status);
                });
    },

   updateCorssRef(){

      if(this.vendorSelected != null && this.vendorSelected !== "undefined" && this.vendorSelected != "-1" ){
        this.vendor_id = this.vendorSelected;
       }else{
        this.vendor_id = "";
      }
      if(this.buyerSelected != null && this.buyerSelected !== "undefined" && this.buyerSelected != "-1" ){
        this.buyer_id = this.buyerSelected;
       }else{
        this.buyer_id = ""
     }
      if(this.shipSelected != null && this.shipSelected !== "undefined" && this.shipSelected != "-1" ){
          this.ship_id = this.shipSelected;        
      }else{
        this.ship_id = "" ;
      }

      this.vendor_code =  this.$refs.ipVendorCode.value.trim();
      this.buyer_code =   this.$refs.ipBuyeCode.value.trim();
      this.ship_code = this.$refs.ipShipCode.value.trim();
      
      this.currency_id  = this.currencySelected;
      this.currency_code =  this.currencies.filter(x=> x.currency_type_id === this.currencySelected)[0].currency_type_code;
    
      this.document_id = this.documentId ;
      this.community_id = this.communitySelected ;
      this.routing_id = this.routeSelected;
    
      swal({
        title: "",
        text: "Are you sure, to update Corss Reference & Route?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Update it!",
        closeOnConfirm: true
      },() => {
        
            axios({ method: "POST", "url": Vue.prototype.$hostname +  "documentxrefroutes", 
                "data": {
                  document_id : this.document_id,
                  community_id : this.community_id,
                  vendor_id : this.vendor_id,
                  vendor_code : this.vendor_code,
                  buyer_id : this.buyer_id,
                  buyer_code : this.buyer_code,
                  ship_id : this.ship_id,
                  ship_code : this.ship_code,
                  currency_id : this.currency_id,
                  currency_code : this.currency_code,
                  routing_id : this.routing_id,
                  doctype_id : this.doc_type_id
                }, 
                 "headers": 
                  { 
                    "content-type": "application/json" ,
                    "authorization": "bearer " + localStorage.getItem('id_token') 
                  }  }).then
                (
                  result => {
                    sweetAlert('Data has been updated successfully!', '', 'success')
                 }, 
                error => {
                console.error(error);
                sweetAlert('Something\'s Wrong!', error, 'error')
                });
        
      })
    },
   checkTokenExpired(){
    if(this.refreshToken_Event_Fired == 0){
    this.getTokenExpiryTime();/* Get Token Expiry time  in Minutes */
    if(this.diffMins <= Vue.prototype.$session_Expire_in && this.diffMins > 0  ){ /* If Token Expiring in (expires_in from service) Mins,then get refereh token */
      this.refreshToken_Event_Fired = 1 ;
      this.getRefreshToken();
      this.refreshToken_Event_Fired = 0;
    }
     }
    },
    async getRefreshToken() {
    this.input['refreshtoken'] = localStorage.getItem('refresh_token')
    await axios({ method: "POST", "url": Vue.prototype.$appName + "token/refreshtoken", 
      "data": this.input, 
      "headers": { "Access-Control-Allow-Origin" : "*",
      "content-type": "application/json" } }).then
      (
          result => {
          this.response = result.data;
          localStorage.setItem('id_token', result.data.access_token);
          localStorage.setItem('refresh_token', result.data.refresh_token);

          var now = new Date();
          now.setMinutes(now.getMinutes() + Math.floor(result.data.expires_in / 60)  ); // timestamp
          now = new Date(now); // Date object
          localStorage.setItem('expiry_date', now);
         }, 
      error => {
        this.refreshToken_Event_Fired = 0;
        console.error(error);
      });

    },
    getTokenExpiryTime() {
      var expiry_date =  new Date(localStorage.getItem('expiry_date'));
      var today = new Date();
      var diffMs = (expiry_date - today); // milliseconds between now & logintime
      this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
       
    },
     getRoutingIdByCommunity(communitySelected){
      if(localStorage.getItem('id_token')){
         this.loaded = 1;
         axios({ method: "GET", "url": Vue.prototype.$hostname + "getroutingbycommnity/" + communitySelected , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                     this.routeSelected = result.data.routingId;
                      this.loaded = 2;
                  }, 
                error => {
                    console.error(error);
                     this.sessionExpired(error.response.status);
                });
         
        }       
    }
  },
 created() {
     if(!localStorage.getItem('id_token') ){
       this.$router.push({name: 'Login'});
     }else{
     this.checkTokenExpired();
     this.communityId = CryptoJS.AES.decrypt( this.$route.query.comId, 'corcentric').toString(CryptoJS.enc.Latin1);
     this.documentId =CryptoJS.AES.decrypt( this.$route.query.docId, 'corcentric').toString(CryptoJS.enc.Latin1);
     this.defaultCommunity = CryptoJS.AES.decrypt( this.$route.query.comId, 'corcentric').toString(CryptoJS.enc.Latin1);
     this.bindHeaderData();
     this.bindRawXMLTransaction(this.communityId,1); 
     this.bindCommunity();
     this.bindVendorDetails(this.communityId);
     this.bindBuyerDetails(this.communityId);
     this.bindRoutes();
     this.getRoutingIdByCommunity(this.communityId);
     this.bindCurrency();
     }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/integration-staging/UpdateDocumentData.vue